<div class="shell" [class.mobile-nav-open]="mobileNavOpen()">
  <!-- Mobile drawer backdrop -->
  <div class="mobile-backdrop" (click)="closeMobileNav()"></div>

  <!-- SIDEBAR -->
  <!-- The close-on-tap handler lives on the nav links, not here. On the
       <aside> it also fired for the user-menu button nested inside, so
       opening that menu slid the drawer shut underneath it and the menu
       read as "not opening". Tapping outside is handled by .mobile-backdrop. -->
  <aside class="sidebar">
    <div class="brand">
      <img
        class="brand-logo"
        [src]="themeService.isDark() ? 'assets/ezwork-logo-silver.png' : 'assets/ezwork-logo-blue.png'"
        alt="EZatWork"
      />
      <div class="brand-mode" *ngIf="modeName()">{{ modeName() }}</div>
    </div>

    <nav class="nav">
      <a
        *ngFor="let n of visibleNav()"
        class="nav-item"
        [class.active]="isActive(n)"
        [routerLink]="n.route"
        (click)="closeMobileNav()"
      >
        <mat-icon>{{ n.icon }}</mat-icon>
        <span class="nav-label">{{ resolveLabelKey(n.key, n.labelKey) | translate }}</span>
        <mat-icon *ngIf="showLockOn(n)" class="nav-lock" aria-hidden="true">lock</mat-icon>
      </a>
    </nav>

    <div class="user-card">
      <button class="user-btn" [matMenuTriggerFor]="userMenu" aria-label="User menu">
        <div class="user-avatar" [class.user-avatar--img]="!!user()?.avatarUrl && !avatarBroken()">
          @if (user()?.avatarUrl && !avatarBroken()) {
            <img [src]="user()?.avatarUrl" alt="" (error)="avatarBroken.set(true)">
          } @else {
            {{ userInitials() }}
          }
        </div>
        <div class="user-info">
          <div class="user-name">{{ user()?.firstName }} {{ user()?.lastName }}</div>
          <div class="user-sub">{{ modeName() }} workspace</div>
        </div>
        <mat-icon class="user-chev">more_vert</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="goProfile()">
          <mat-icon>person</mat-icon><span>{{ 'nav.profile' | translate }}</span>
        </button>
        <button mat-menu-item (click)="goBusinessSettings()">
          <mat-icon>business</mat-icon><span>{{ 'nav.businessSettings' | translate }}</span>
        </button>
        <button mat-menu-item (click)="goSettings()">
          <mat-icon>settings</mat-icon><span>{{ 'nav.settings' | translate }}</span>
        </button>
        <button mat-menu-item (click)="openSupport()">
          <mat-icon>support_agent</mat-icon><span>{{ 'nav.support' | translate }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon><span>{{ 'nav.logout' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </aside>

  <!-- MAIN -->
  <div class="main">
    <header class="topbar">
      <button
        class="hamburger-btn"
        type="button"
        aria-label="Open menu"
        (click)="toggleMobileNav()"
      >
        <mat-icon>{{ mobileNavOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>

      <div class="title-block">
        <div class="crumb">{{ pageMeta().crumbKey | translate }}</div>
        <div class="page-title">{{ pageMeta().titleKey | translate }}</div>
      </div>

      <div class="topbar-actions">
        <!-- Active timer pill — only when a timer is running -->
        <a
          *ngIf="activeTimerSvc.activeTimer() as t"
          class="timer-pill"
          routerLink="/finance/time-tracking"
        >
          <span class="pulse" [class.paused]="activeTimerSvc.isPaused()"></span>
          <span class="mono">{{ formattedTimerTime() }}</span>
          <button
            *ngIf="pipTimerSvc.isSupported() && !pipTimerSvc.isPipActive()"
            type="button"
            id="tour-pip-btn"
            class="timer-popout"
            aria-label="Pop out timer"
            (click)="openPipTimer($event)"
            matTooltip="Pop out timer"
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="14" rx="2"></rect>
              <path d="M11 13h6v5"></path>
              <path d="M17 13l-6 6"></path>
            </svg>
          </button>
        </a>

        <!-- Notifications bell (uses existing component for behaviour) -->
        <app-notification-bell></app-notification-bell>

        <!-- Quick-add menu -->
        <button class="primary-btn" [matMenuTriggerFor]="newMenu">
          <mat-icon>add</mat-icon>
          <span class="primary-btn-label">{{ 'nav.new' | translate }}</span>
        </button>
        <mat-menu #newMenu="matMenu">
          <button mat-menu-item (click)="goNewInvoice()">
            <mat-icon>description</mat-icon><span>{{ 'nav.invoices' | translate }}</span>
          </button>
          <button mat-menu-item (click)="goNewClient()">
            <mat-icon>person_add</mat-icon><span>{{ 'nav.clients' | translate }}</span>
          </button>
          <button mat-menu-item (click)="goNewProject()">
            <mat-icon>folder</mat-icon><span>{{ 'nav.projects' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </header>

    <app-ita-reconnect-banner></app-ita-reconnect-banner>
    <app-announcement-banner></app-announcement-banner>

    <main class="content">
      <router-outlet></router-outlet>
      <!-- Free-plan overlay: blurs gated features (Time, Contracts) and
           offers an Upgrade CTA. Renders nothing on Pro or non-gated routes. -->
      <app-plan-gate></app-plan-gate>
    </main>
  </div>
</div>
